import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminGuard } from 'src/app/auth/admin.guard';
import { UserListComponent } from './user-list/user-list.component';
import { PendingUsersComponent } from './pending-users/pending-users.component';
import { AuthGuard } from 'src/app/auth/auth.guard';
import { UserRoles } from 'src/app/enums/userRoles.enum';

const routes: Routes = [
  {
    path: 'userlist',
    component: UserListComponent,
    canActivate: [AuthGuard, AdminGuard],
    data: {
      roles: [UserRoles.SuperAdmin, UserRoles.Admin],
      preload: true,
      breadcrumb: 'Home/KMS Portal/Users'
    },
  },
  {
    path: 'pendingusers',
    component: PendingUsersComponent,
    canActivate: [AdminGuard]
  }
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class UsersRoutingModule {


}


